<template>
  <div>
    <loader v-if="!readyToRender"></loader>
    <div class="col-md-12" v-else>
      <h3>Liste des notifications déjà envoyées</h3>
      
      <div v-if="manual_notifications.length > 0">
        <div class="table-responsive">
          <table class="table table-hover table-condensed table-detailed search-table" id="detailedTable">
              <thead>
                  <tr>
                      <th class="column--medium">Date</th>
                      <th>Type</th>
                      <th>Message</th>
                      <th class="column--small">Email</th>
                      <th class="column--small">SMS</th>
                      <th class="column--medium text-center">Vue</th>
                  </tr>
              </thead>
              <tbody>
                  <tr v-for="(notification, id) in manual_notifications" :key="id">
                      <td>{{ notification.created_at | dateFormat }}</td>
                      <td>{{ notification.data.notification_declension.name }}</td>
                      <td>{{ notification.data.notification_declension.message }}</td>
                      <td class="text-center">
                        <i v-if="notification.data.notification_declension.email" class="glyphicon glyphicon-ok"></i>
                        <i v-else class="glyphicon glyphicon-remove"></i>
                      </td>
                      <td class="text-center">
                        <i v-if="notification.data.notification_declension.sms" class="glyphicon glyphicon-ok"></i>
                        <i v-else class="glyphicon glyphicon-remove"></i>
                      </td>
                      <td class="text-center">
                        <span v-if="notification.read_at">{{ notification.read_at | dateFormat }}</span>
                        <i v-else class="glyphicon glyphicon-remove"></i>
                      </td>
                  </tr>
              </tbody>
          </table>
        </div>
      </div>

      <div v-else>
        <hr>
        
        <div class="alert alert-info">
            <i class="fa fa-info-circle"></i> Aucune notification n'a encore été envoyée à ce client
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.glyphicon-ok {
  color: green;
}
.glyphicon-remove {
  color: darkred;
}
.column--small {
  width: 70px;
}
.column--medium {
  width: 150px;
}
</style>

<script type="text/babel">
import { mapState, mapActions } from 'vuex'
import Loader from 'views/Loader'

export default {
  data () {
    return {
      readyToRender: false,
      customerId: this.$store.state.customer.id
    }
  },
  components: {
    Loader
  },
  mounted () {
    this.getCustomerManualNotifications(this.customerId).then(response => { this.readyToRender = true })
  },
  methods: {
    ...mapActions('customer', ['getCustomerManualNotifications']),

    getNotificationsAfterSending() {
      this.readyToRender = false

      setTimeout(() => { 
        this.getCustomerManualNotifications(this.customerId)
          .then(response => { this.readyToRender = true })
      }, 4000)
    }
  },
  computed: {
    ...mapState('customer', ['manual_notifications'])
  },
  filters: {
    dateFormat(date) {
      return moment(date).format('DD/MM/YYYY HH:mm')
    }
  }
}
</script>



// WEBPACK FOOTER //
// client/components/Customer/AlertsContent/AlertsTable.vue